import Spinner from "../../Spinner.jsx";
import UserDropdownProjectItem from "./UserDropdownProjectItem.jsx";
import {useTranslation} from "react-i18next";
import {useContext, useEffect, useMemo, useState} from "react";
import {GlobalContext} from "../../../utils/context/GlobalContextProvider.jsx";
import {useNavigate} from "react-router-dom";
import ProjectListCreateLink from "./ProjectListCreateLink.jsx";
import ModernSearchInput from "../../ModernSearchInput.jsx";
import {filterDropdownProjects} from "./projectDropdownSearch.js";

export default function UserDropdownProjectList() {
    const {context, setCurrentProjectId} = useContext(GlobalContext);
    const {t} = useTranslation();
    const [searchQuery, setSearchQuery] = useState('');
    const projects = context.currentUserProjects;
    const searchVisible = projects.length > 5;

    useEffect(() => {
        if (!context.userDropdownOpened) setSearchQuery('');
    }, [context.userDropdownOpened]);

    const orderedProjects = useMemo(() => {
        const currentProject = projects.find((project) => project.id === context.currentProjectId);
        return currentProject
            ? [currentProject, ...projects.filter((project) => project.id !== currentProject.id)]
            : projects;
    }, [context.currentProjectId, projects]);

    const matchingProjects = useMemo(
        () => filterDropdownProjects(orderedProjects, searchQuery),
        [orderedProjects, searchQuery],
    );
    const displayedProjects = searchQuery.trim() ? matchingProjects : matchingProjects.slice(0, 5);
    const hiddenProjectCount = projects.length - displayedProjects.length;

    return (
        <div className="border-b border-slate-200 dark:border-slate-700">
            {searchVisible && <div className="px-3 pt-3">
                <ModernSearchInput
                    value={searchQuery}
                    onChange={setSearchQuery}
                    label={t('projects.search-placeholder', {defaultValue: 'Hledat projekt...'})}
                    clearLabel={t('clear', {defaultValue: 'Vymazat'})}
                    compact
                />
            </div>}
            <ul className="max-h-96 overflow-y-auto py-2">
                {!context.currentUserProjectsLoaded && <Spinner className="mx-auto"/>}
                {context.currentUserProjectsLoaded && displayedProjects.map((project) => (
                    <UserDropdownProjectItem
                        key={project.id}
                        project={project}
                        isCurrent={project.id === context.currentProjectId}
                        currentProjectId={context.currentProjectId}
                        setCurrentProjectId={setCurrentProjectId}
                    />
                ))}

                {!searchQuery.trim() && hiddenProjectCount > 0 && <ProjectListSettingsLink moreAmount={hiddenProjectCount}/>}
                {searchQuery.trim() && displayedProjects.length === 0 && <li className="px-4 py-6 text-center text-sm text-slate-500 dark:text-slate-400">{t('projects.no-results', {defaultValue: 'Žádný projekt nenalezen.'})}</li>}
                {projects.length === 0 && <ProjectListCreateLink/>}
            </ul>
        </div>
    );
}

function ProjectListSettingsLink({moreAmount}) {
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <li
            className="flex cursor-pointer justify-center px-3 py-1 text-sm text-slate-500 hover:text-slate-600 dark:text-gray-400 dark:hover:text-gray-300"
            onClick={() => navigate('/projects')}
        >
            {t('projects.and-x-more', {count: moreAmount})}
        </li>
    );
}
